<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <h2 class="bb-page-title">{{ 'إنشاء حيوان' | transloco }}</h2>
        <p class="bb-page-subtitle">{{ 'اختار العميل وسجل بيانات الحيوان' | transloco }}</p>
      </div>

      <div class="bb-header-actions">
        <button type="button" class="bb-btn bb-btn-secondary" routerLink="/pets">
          {{ 'Back' | transloco }}
        </button>
      </div>
    </div>

    <div class="bb-card bb-p-20">
      <form class="bb-grid bb-gap-16" [formGroup]="petForm" (ngSubmit)="savePet()">

        <div class="bb-form-grid">
          <div class="bb-field bb-field-full">
            <label class="bb-label" for="client_id">{{ 'العميل' | transloco }}</label>
            <div class="bb-select-wrap">
              <select
                class="bb-select"
                id="client_id"
                formControlName="client_id"
                [ngClass]="{
                  'is-invalid': shouldShowError('client_id'),
                  'is-valid': petForm.get('client_id')?.touched && petForm.get('client_id')?.valid
                }"
              >
                <option value="">{{ '-- اختار العميل --' | transloco }}</option>
                <option *ngFor="let client of clients" [value]="client.id">
                  {{ getClientLabel(client) }}
                </option>
              </select>
            </div>
            <div class="bb-field-error" *ngIf="shouldShowError('client_id')">
              {{ 'العميل مطلوب' | transloco }}
            </div>
          </div>
        </div>

        <div class="bb-form-grid">
          <div class="bb-field">
            <label class="bb-label" for="pet_type">{{ "pet" | transloco }}</label>
            <div class="bb-select-wrap">
              <select
                class="bb-select"
                id="pet_type"
                formControlName="pet_type"
                [ngClass]="{
                  'is-invalid': shouldShowError('pet_type'),
                  'is-valid': petForm.get('pet_type')?.touched && petForm.get('pet_type')?.valid
                }"
              >
                <option value="">-- {{ 'choose' | transloco }} --</option>
                <option value="0">{{ "cats" | transloco }}</option>
                <option value="1">{{ "dogs" | transloco }}</option>
                <option value="2">{{ "birds" | transloco }}</option>
                <option value="4">{{ "cats&dogs" | transloco }}</option>
                <option value="3">{{ "other" | transloco }}</option>
              </select>
            </div>
            <div class="bb-field-error" *ngIf="shouldShowError('pet_type')">
              {{ 'نوع الحيوان مطلوب' | transloco }}
            </div>
          </div>

          <div class="bb-field">
            <label class="bb-label" for="name">{{ "Pet name" | transloco }}</label>
            <input
              class="bb-input"
              id="name"
              type="text"
              formControlName="name"
              placeholder="{{ 'Pet name' | transloco }}"
              [ngClass]="{
                'is-invalid': shouldShowError('name'),
                'is-valid': petForm.get('name')?.touched && petForm.get('name')?.valid
              }"
            />
            <div class="bb-field-error" *ngIf="shouldShowError('name')">
              {{ 'اسم الحيوان مطلوب' | transloco }}
            </div>
          </div>
        </div>

        <div class="bb-form-grid">
          <div class="bb-field">
            <label class="bb-label" for="breed">{{ 'Breed' | transloco }}</label>
            <input
              class="bb-input"
              id="breed"
              type="text"
              formControlName="breed"
              placeholder="{{ 'Breed' | transloco }}"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="color">{{ 'Color' | transloco }}</label>
            <input
              class="bb-input"
              id="color"
              type="text"
              formControlName="color"
              placeholder="{{ 'Color' | transloco }}"
            />
          </div>
        </div>

        <div class="bb-form-grid">
          <div class="bb-field">
            <label class="bb-label" for="special_markings">{{ 'Special Markings' | transloco }}</label>
            <input
              class="bb-input"
              id="special_markings"
              type="text"
              formControlName="special_markings"
              placeholder="{{ 'Special Markings' | transloco }}"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="date_of_birth">{{ 'Date of Birth' | transloco }}</label>
            <input
              class="bb-input"
              id="date_of_birth"
              type="date"
              formControlName="date_of_birth"
            />
          </div>
        </div>

        <div class="bb-form-grid">
          <div class="bb-field">
            <label class="bb-label" for="gender">{{ 'Gender' | transloco }}</label>
            <div class="bb-select-wrap">
              <select class="bb-select" id="gender" formControlName="gender">
                <option value="male">{{ 'Male' | transloco }}</option>
                <option value="female">{{ 'Female' | transloco }}</option>
              </select>
            </div>
          </div>

          <div class="bb-field">
            <label class="bb-label">{{ 'Spayed / Neutered' | transloco }}</label>
            <label class="bb-check-line">
              <input class="bb-checkbox" type="checkbox" formControlName="spayed_neutered" />
              <span>{{ "Yes" | transloco }} / {{ "no" | transloco }}</span>
            </label>
          </div>
        </div>

        <div class="bb-flex bb-items-center bb-gap-12 bb-wrap">
          <button class="bb-btn bb-btn-primary" type="submit" [disabled]="petForm.invalid || saving">
            {{ saving ? 'جاري الحفظ...' : 'حفظ' }}
          </button>

          <button class="bb-btn bb-btn-secondary" type="button" (click)="resetForm()">
            {{ 'Reset' | transloco }}
          </button>
        </div>

      </form>
    </div>

  </div>
</section>